import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loginimg from "../../Components/assets/images/login.png";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import ReactCodeInput from "react-code-input";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function Signupverification() {
  const location = useLocation();
  const [token, setToken] = useState([]);
  console.log(token);
  const [loading, setLoading] = useState(false);
  const [valueInput, setValueInput] = useState(false);
  const [valid, setValid] = useState(true);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [response, setResponse] = useState({
    success: null,
    error: null,
  });

  const navigate = useNavigate();

  const postVerify = async (e) => {
    e.preventDefault();
    if (token === "") {
      setResponse({
        success: null,
        error: "Please enter your verification code",
      });
    } else {
      setLoading(true);
      await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}/user/register`,
        data: {
          ...location.state,
          verification_code: token,
        },
      })
        .then((res) => {
          console.log(res.data);
          if (res.data.status === true) {
            navigate("/login", { replace: true });

            setResponse({
              success: "Your account has been verified",
              error: null,
            });

            enqueueSnackbar(
              "Your account has been verified. Login to continue",
              {
                variant: "success",
              }
            );
            setToken("");
          } else {
            setResponse({
              success: null,
              error: "Please enter a valid verification code",
            });
          }
        })
        .catch((error) => {
          setResponse({
            success: null,
            error: "Server error",
          });
        });
      setLoading(false);
    }

    setTimeout(() => {
      setResponse({
        success: null,
        error: null,
      });
    }, 5000);
  };

  const handleValueInput = (e) => {
    setToken(e);
  };

  return (
    <>
      <div className="code-verification-main">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 ">
              <div className="login-image">
                <img src={Loginimg} alt="login image" />
              </div>
            </div>
            <div className=" col-lg-6 col-md-6 login-form">
              <div className="login-title">
                <h6>Verify with Nepali Garden</h6>
              </div>
              {response.error ? (
                <>
                  <Alert severity="error">{response.error}</Alert>
                </>
              ) : null}
              <div className="code-verify">
                <div className="row">
                  <ReactCodeInput
                    name="code verification"
                    inputMode="numeric"
                    fields={4}
                    type="text"
                    onChange={(e) => handleValueInput(e)}
                    isValid={valid}
                  />
                </div>
                <div className="button">
                  <LoadingButton
                    className="btn"
                    loading={loading}
                    variant="outlined"
                    onClick={postVerify}
                  >
                    Verify Your Code
                  </LoadingButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
